var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-link',{attrs:{"to":{name: 'UploadPageDatasetDetails', query: { 
          catalog: _vm.getCatalog.id, 
          locale: _vm.$route.query.locale 
        }, 
        params: {
          id: _vm.getID,
          title: _vm.getTitle,
          description: _vm.getDescription,
          keywords: _vm.getKeywords,
          catalog: _vm.getCatalog.id,
          category: _vm.getCategories,
          contact_point: _vm.getContactPoints,
          publisher: _vm.getPublisher,
          distributions: _vm.getDistributions,
        }
  }}},[_c('button',{staticClass:"mt-1 btn btn-sm btn-primary"},[_vm._v(" "+_vm._s(_vm.$t('message.datasetDetails.edit'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }